import React, { PropsWithChildren, ReactNode } from "react";

export interface TabItemProps extends PropsWithChildren<{}> {
  title?: string;
  TabItemComponent?: ReactNode;
  children?: ReactNode;
  dataTrackId?: string;
}

const TabItem = (props: TabItemProps) => {
  const { children, title, TabItemComponent, ...rest } = props;
  return (
    <div className="xh-tabbar-item" data-track-id={props.dataTrackId} {...rest}>
      {TabItemComponent ? TabItemComponent : title}
      {children}
    </div>
  );
};

export default TabItem;
